<template>
    <div class="rv" v-loading.fullscreen.lock="fullscreenLoading">
        <section class="hero-section ptb-100" style="background:url(https://apv.serpar.gob.pe/writable/uploads/raices/header.jpg); background-repeat: no-repeat;
background-size: cover;
background-position: center center;">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-9 col-lg-7">
                        <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                            <img src="https://apv.serpar.gob.pe/writable/uploads/services/raicesdevida.jpg" style="border-radius:50%; height:200px;"/>
                            <h1 class="text-white mb-0">REGISTRO</h1>
                            <h3 class="text-white mb-0">Llena tus datos y sigue el proceso de plantación de tu árbol</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="steps-header">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-md-10 pt-4">
                        <el-steps :active="step" finish-status="success" align-center>
                            <el-step title="Método de pago"></el-step>
                            <el-step title="Datos de certificación"></el-step>
                            <el-step title="Selecciona la modalidad"></el-step>
                            <el-step title="Datos de facturación"></el-step>
                            <el-step title="Resumen"></el-step>
                        </el-steps>
                    </div>
                </div>
            </div>
        </section>
        <section class="customer-review-section py-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-11 col-md-11">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                            <div v-if="step== 0" class="ep-step-one">
                                <div class="row">
                                    <div class="col-sm-2"></div>
                                    <div class="col sm-10">
                                        <el-radio-group v-model="ruleForm.metodo">
                                            <el-radio label="1" border class="w-75 mb-4">Pago en línea</el-radio>
                                            <el-radio label="2" border class="w-75 ml-0">Pago en efectivo o por transferencia</el-radio>
                                        </el-radio-group>
                                        <el-divider></el-divider>
                                        <div v-if="ruleForm.metodo==1">
                                            <p>
                                                <b>A través de este método podrás realizar el pago con tu tarjeta de crédito o débito.</b><br>
                                                <img src="https://escuelasvirtuales.serpar.gob.pe/assets/media/cards/visa.png" alt="visa" width="24" height="24">
                                                <img src="https://escuelasvirtuales.serpar.gob.pe/assets/media/cards/mastercard.png" alt="mastercard" width="24" height="24">
                                                <img src="https://escuelasvirtuales.serpar.gob.pe/assets/media/cards/amex.png" alt="américan express" width="24" height="24">
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p>
                                                <b>Con este método, deberás realizar el pago antes de continuar con el registro, <br>debido a que al finalizar te solicitaremos la imagen de la captura o fotografía de tu comprobante.</b>
                                            </p>
                                            <p>Contamos con tres opciones para que realices el pago:</p>
                                            <p>
                                                <b>Transferencia bancaria a nuestra cuenta del Scotiabank:</b><br>A nombre de: Servicio de Parques de Lima<br> Cta. Cte. soles N.º 1203203<br>CCI: 009 170 000001203203 23
                                            </p>
                                            <p>
                                                <b>Depósito en agente o ventanilla del Scotiabank:</b><br>A nombre de: Servicio de Parques de Lima <br>Cta. Cte. soles N.º 1203203
                                            </p>
                                            <p>
                                                <b>Pago en efectivo en la caja de la institución (Serpar):</b><br>Dirección: Jirón Lampa 182 (2do piso) – Cercado de Lima<br>Horario de atención: Lunes a viernes de 8 a.m. a 4 p.m.
                                            </p>
                                            <p>
                                                <b>El monto a pagar debe corresponder a la modalidad de Raíces de Vida de tu interés:</b><br> • S/ 188 - Un árbol para siempre (Perpetuo)<br>• S/ 94 - Echando raíces (5 años)
                                            </p>

                                            <el-form-item prop="yapague">
                                                <el-checkbox v-model="ruleForm.yapague" name="yapague">Ya realicé el abono a la cuenta y tengo la imagen del comprobante de pago.
                                                    <el-tooltip class="item" effect="dark" placement="top-start">
                                                        <template slot="content">
                                                            Antes de hacer clic en continuar, es importante<br> que cuentes con la imagen del comprobante de pago,<br> pues se te solicitará subirla al finalizar el registro.
                                                        </template>
                                                        <el-button size="mini" circle>?</el-button>
                                                    </el-tooltip>
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="step == 1" class="ep-setp-one">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 d-block d-sm-block d-md-none mb-4">
                                        <img class="w-100" src="https://apv.serpar.gob.pe/writable/uploads/raices/certificado.jpg" alt="">
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <el-form-item label="Motivo de la plantación" prop="motivo" >
                                            <el-select v-model="ruleForm.motivo" placeholder="Selecciona" class="w-100" @change="getDedicatoria">
                                                <el-option v-for="item in motivos" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item v-if="ruleForm.motivo==0" label="Motivo personalizado" prop="motivocustom">
                                            <el-input v-model="ruleForm.motivocustom" maxlength="80" show-word-limit></el-input>
                                        </el-form-item>
                                        <!--<el-form-item label="Fecha conmemorativa" prop="fcon">
                                            <el-date-picker v-model="ruleForm.fcon" type="date" placeholder="seleccione" format="dd/MM/yyyy">
                                            </el-date-picker>
                                        </el-form-item>-->
                                        <el-form-item label="Dedicado a" prop="dedicado">
                                            <br><span>(Familia, persona, grupo, empresa)</span>
                                            <el-input v-model="ruleForm.dedicado"  maxlength="80" show-word-limit placeholder="(Nombre (s) a quien se dedica el árbol) "></el-input>
                                        </el-form-item>
                                        <el-form-item label="Dedicatoria" prop="mensaje">
                                            <br><span>(Puedes editar y/o colocar tu inspiración)</span>
                                            <el-input type="textarea" :rows="4" v-model="ruleForm.mensaje" maxlength="250" show-word-limit></el-input>

                                        </el-form-item>
                                        <el-form-item label="Para" prop="para">
                                            <el-input v-model="ruleForm.para"  maxlength="80" show-word-limit placeholder="(Persona o grupo que recibe el regalo)"></el-input>
                                        </el-form-item>
                                        <el-form-item label="De parte de" prop="departe">
                                            <el-input v-model="ruleForm.departe"  maxlength="80" show-word-limit placeholder="(Nombre de quien regala) "></el-input>
                                        </el-form-item>
                                        <div class="block mb-4"></div>
                                        <el-divider content-position="left">Datos de la plantación</el-divider>
                                        <el-form-item label="Selecciona el lugar" prop="lugar">
                                            <el-select v-model="ruleForm.lugar" placeholder="Selecciona" class="w-100" @change="getEspecie">
                                                <el-option v-for="item in listLugares" :key="item.text" :label="item.value" :value="item.text"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Especie de árbol" prop="especie">
                                            <el-select v-model="ruleForm.especie" placeholder="Selecciona" @change="getPrecios">
                                                <el-option v-for="item in listEspecie" :key="item.text" :label="item.value" :value="item.text"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="col-sm-12 col-md-6 d-none d-sm-none d-md-block">
                                        <h4 class="text-muted text-center d-none">Modelo de certificado</h4>
                                        <img class="w-100" src="https://apv.serpar.gob.pe/writable/uploads/raices/certificado.jpg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div v-if="step == 2" class="ep-setp-one">
                                <div class="row planes">
                                    <el-form-item prop="getSchedule">
                                        <el-radio-group v-model="ruleForm.getSchedule">
                                            <div v-for="item in listPrecios" :key="item.productoId" class="col-lg-12">
                                                <label class="option mb-2 p-2 pr-4 pt-4 pb-3 border">

                                                    <span class="option-control">
                                                        <span class="radio">
                                                        <el-radio :label="item.productoId"></el-radio>
                                                        </span>
                                                    </span>
                                                    <span class="option-label border-right w-100 mr-1">
                                                        <span class="option-head">
                                                            <div class="option-title mb-1" v-html="item.alias"></div>
                                                        </span>
                                                        <h1 class="option-body pt-0 text-primary d-none" style="font-size:30px;" v-html="'S/ ' + item.pUnitario"></h1>
                                                    </span>
                                                    <div class="d-flex align-items-center">
                                                        <div class="symbol symbol-circle symbol-success mx-2">
                                                            <img alt="Serpar" :src="'https://apv.serpar.gob.pe/writable/uploads/services/raicesdevida.jpg'">
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        </el-radio-group>
                                        <el-alert
                                            type="warning" :closable="false"
                                            description="El pago por la plantación del árbol no otorga derecho a propiedad del espacio y tampoco a reubicación o remoción de la especie"
                                            show-icon>
                                        </el-alert>

                                        <div v-if="ruleForm.getSchedule=='00499'">
                                            <!--<p>Esta modalidad brinda el beneficio de ingreso gratuito al club zonal para una persona. Indica los datos del beneficiario: </p>-->
                                            <!--<el-form-item prop="benfname" label="Nombre completo" label-width="150px" class="mb-4">
                                                <el-input v-model="ruleForm.benfname" maxlength="50"></el-input>
                                            </el-form-item>
                                            <el-form-item prop="benfdoc" label="DNI"  label-width="150px">
                                                <el-input v-model="ruleForm.benfdoc" maxlength="11"></el-input>
                                            </el-form-item>-->
                                            <div class="col-sm-12 px-4">
                                                <p style="margin-bottom:0">El plan seleccionado incluye:</p>
                                                <p>
                                                    <ul style="line-height:1.5">
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Selección del lugar y especie que se plantará. </span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Mantenimiento eterno del árbol.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Certificado digital y/o físico de la plantación.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Placa conmemorativa en el árbol.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Información periódica sobre el estado del árbol.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Compensación de la especie en caso de daños fortuitos. (10 primeros años)</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Ingreso gratuito al club zonal donde se plantó la especie. (Solo para un beneficiario)</span>
                                                        </li>
                                                    </ul>

                                                </p>
                                                <p style="line-height:1.5">Tiempo estimado de plantación: A partir de los 5 días hábiles <br>Altura del árbol: 2 metros</p>
                                                <p style="line-height:1.5">
                                                    * El certificado que se entregará cuenta con un código QR para registrar a la persona que ingresará de manera gratuita al club zonal donde se realizó la plantación. Este beneficio no tiene fecha de caducidad.
                                                </p>

                                            </div>

                                        </div>
                                        <div v-if="ruleForm.getSchedule=='00498'" class="col-sm-12 px-4">
                                                <p style="margin-bottom:0">El plan seleccionado incluye:</p>
                                                <p>
                                                    <ul style="line-height:1.5">
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Selección del lugar y especie que se plantará.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Mantenimiento del árbol durante 5 años.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Certificado digital y/o físico de la plantación.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Placa conmemorativa en el árbol.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Información periódica sobre el estado del árbol.</span>
                                                        </li>
                                                        <li style="display: flex;align-items: center;">
                                                            <img src="https://apv.serpar.gob.pe/writable/uploads/raices/vineta.png" style="width:30px;" />
                                                            <span>Compensación de la especie en caso de daños fortuitos.</span>
                                                        </li>
                                                    </ul>
                                                </p>
                                                <p style="line-height:1.5">Tiempo estimado de plantación: A partir de los 5 días hábiles <br>Altura del árbol: 2 metros</p>

                                            </div>


                                    </el-form-item>
                                </div>
                            </div>
                            <div v-if="step == 3" class="ep-setp-one">
                                <el-form-item label="Comprobante" label-width="120px" class="mb-4" prop="fndoc">
                                <el-input :placeholder="placeHolder.voucher" v-model="ruleForm.fndoc" class="input-with-select" size="medium" :clearable="true">
                                    <el-select v-model="ruleForm.voucher" slot="prepend" placeholder="Seleccione" @change="changeTpodocument">
                                        <el-option key="B" label="Boleta" value="B"></el-option>
                                        <el-option key="F" label="Factura" value="F"></el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="placeHolder.namebussines" label-width="120px" prop="fname" size="medium">
                                <el-input v-model="ruleForm.fname" :placeholder="placeHolder.namebussines"></el-input>
                            </el-form-item>
                            <el-form-item label="Celular" label-width="120px" prop="fphone">
                                <el-input type="fphone" v-model.number="ruleForm.fphone" placeholder="N° de celular" maxlength="9" size="medium"></el-input>
                            </el-form-item>
                            <el-form-item label="Email" label-width="120px" prop="femail">
                                <el-input v-model="ruleForm.femail" placeholder="Correo electrónico" size="medium"></el-input>
                            </el-form-item>
                            </div>
                            <div v-if="step == 4" class="ep-setp-one">
                                <el-divider content-position="left">Datos de certificación</el-divider>
                                <div class="ml-5">Motivo:{{(ruleForm.motivo == 0) ? ruleForm.motivocustom : motivos[ruleForm.motivo].name}}</div>
                                <div class="ml-5">Dedicado a: {{ruleForm.dedicado}}</div>
                                <div class="ml-5">Dedicatoria: {{ruleForm.mensaje}} </div>
                                <div class="ml-5">Para: {{ruleForm.para}} </div>
                                <div class="ml-5">De parte de: {{ruleForm.departe}} </div>
                                <div class="ml-5">Lugares de plantanción: {{this.detalleA[0].value}}</div>
                                <div class="ml-5">Especie de árbol: {{this.detalleB[0].value}}</div>

                                <el-divider content-position="left">Plan seleccionado</el-divider>
                                <div class="ml-5" v-html="this.detalleC[0].alias"></div>

                                <el-divider content-position="left">Datos de facturación</el-divider>
                                <div class="ml-5">Comprobante: {{placeHolder.voucher}} {{ruleForm.fndoc}}</div>
                                <div class="ml-5">{{placeHolder.namebussines}} {{ruleForm.fname}}</div>
                                <div class="ml-5">Celular: {{ruleForm.fphone}}</div>
                                <div class="ml-5">Email: {{ruleForm.femail}}</div>

                                <el-divider v-if="ruleForm.metodo == 2" content-position="left">Comprobante de pago</el-divider>
                                <el-upload v-if="ruleForm.metodo == 2"
                                    name="file"
                                    class="upload-demo ml-5"
                                    action="https://apv.serpar.gob.pe/raices/upload"
                                    accept=".jpg, .jpeg, .png, .JPG, .JPEG"
                                    :on-exceed="handleExceed"
                                    :on-progress="handleProgress"
                                    :before-upload="beforeUpload"
                                    :on-success="handleSuccess"
                                    :on-error="handleError">
                                    <el-button size="small" type="primary">Clic para subir archivo</el-button>
                                    <div slot="tip" class="el-upload__tip">Solo archivos jpg/png con un tamaño menor de 2Mb</div>
                                </el-upload>

                                <el-form-item prop="terms">
                                    <el-checkbox v-model="ruleForm.terms" name="terms">He leído y acepto los
                                        <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf" target="_blank"><b>Términos y Condiciones</b></a></el-checkbox>
                                </el-form-item>
                            </div>
                        </el-form>
                        <button class="btn outline-btn mb-3 mt-3" @click.prevent="epBack('ruleForm')">Anterior</button>
                        <button class="btn outline-btn my-5" @click.prevent="submitForm('ruleForm')">{{(step == 4)? (ruleForm.metodo == 1 ? 'Ir a pagar' : 'Finalizar compra'):'Siguiente'}}</button>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
import moment from 'moment';
import data from "@/data/common";

export default {
    data() {
        var checkAge = (rule, value, callback) => {
            if (!value) {
                if (!this.ruleForm.getSchedule)
                    return callback(new Error(`Aún no ha seleccionado ningun plan.`));
                else if (this.listDetails[0].scheduls.length == 0)
                    return callback(new Error(`Lo sentimos, no contamos con planes disponibles.`));
                else
                    return callback(new Error(`Tiene que seleccionar un plan.`));
            } else {
                callback();
            }
        };
        return {
            step: 0,
            totalSteps: 5,
            fullscreenLoading: false,
            ruleForm:{
                idvoucher: null,
                metodo: '1',
                yapague: [],
                motivo: null,
                motivocustom: null,
                dedicado: null,
                mensaje: null,
                para: null,
                departe: null,
                lugar: null,
                especie: null,
                benfname: null,
                benfdoc: null,
                terms: false,
                getSchedule: '',
                voucher: 'B',
                fndoc: '',
                fname: '',
                fphone: '',
                femail: '',
                nomproduct: '',
                precio: 0,
                acepto: false
            },
            motivos: data.motivos,
            customs: data.customs,
            detalleA:[],
            detalleB:[],
            detalleC:[],
            placeHolder:{voucher: 'DNI', namebussines: 'Nombres'},
            listLugares:[],
            listEspecie:[],
            listPrecios: [],
            rules:{
                yapague: [
                    { type: 'array', required: true, message: 'Falta seleccionar esta opción', trigger: 'change' }
                ],
                motivo: [{
                    required: true,
                    message: 'Selecciona el motivo',
                    trigger: 'change'
                }],
                motivocustom: [{
                    required: true,
                    message: 'Ingrese motivo personalizado',
                    trigger: 'blur'
                }],
                dedicado: [{
                    required: true,
                    message: 'Falta ingresar',
                    trigger: 'blur'
                }],
                mensaje: [{
                    required: true,
                    message: 'Falta ingrese mensaje',
                    trigger: 'blur'
                }],
                para: [{
                    required: true,
                    message: 'Falta ingresar',
                    trigger: 'blur'
                }],
                departe: [{
                    required: true,
                    message: 'Falta ingresar',
                    trigger: 'blur'
                }],
                benfname: [{
                    required: true,
                    message: 'Falta ingresar datos completos del beneficiario',
                    trigger: 'blur'
                }],
                benfdoc: [{
                    required: true,
                    message: 'Falta ingresar DNI del beneficiario',
                    trigger: 'blur'
                }],
                lugar: [{
                    required: true,
                    message: 'Selecciona lugar de plantación',
                    trigger: 'change'
                }],
                especie: [{
                    required: true,
                    message: 'Selecciona especie',
                    trigger: 'change'
                }],
                getSchedule: [{
                    validator: checkAge,
                    trigger: 'change'
                }],
                fndoc: [{
                    required: true,
                    message: 'Ingrese nro. documento',
                    trigger: 'blur'
                }],
                fname: [{
                    required: true,
                    message: 'Ingrese la información solicitada ',
                    trigger: 'blur'
                }, ],
                fphone: [{
                        required: true,
                        message: 'Ingrese un número de celular'
                    },
                    {
                        type: 'number',
                        message: 'Celular debe ser números'
                    }
                ],
                femail: [{
                        required: true,
                        message: 'Ingrese una dirección de correo electrónico',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Ingrese una dirección de correo electrónico correcta',
                        trigger: ['blur', 'change']
                    }
                ],
                terms: [
                    { required: true, message: 'Falta seleccionar los terminos', trigger: ['blur', 'change'] }
                ],
            }
        }
    },
    methods:{
        epBack(formName) {
            if (this.step != 0) {
                this.step--;
                this.ruleForm.terms = false;
                this.textePresencial = 'Siguiente';
            }else{
                this.$router.push({path: `/raices-de-vida`})
            }

        },
        handleExceed(files, fileList) {
            this.$message.warning(`El límite es 1, haz seleccionado ${files.length} archivos esta vez, añade hasta ${files.length + fileList.length}`);
        },
        beforeUpload(){
            console.log('beforeupload');
            /*if(this.documents.tipo == null){
                this.$notify.error({title: 'Campos vacios', message: 'Falta seleccionar el tipo de archivo a subir'});
                return false;
            }*/
        },
        handleProgress(event, file, fileList){
        },
        handleSuccess(response, file, fileList){
            if(response.status == 'success'){
                this.ruleForm.idvoucher = response.id;
                console.log(this.ruleForm.idvoucher);
            }else{
                this.$alert(response.message, 'Error ', {type: 'warning'});
            }
            console.log(response);
        },
        handleError(err, file, fileList){
            const e = JSON.parse(err.message);
            this.$alert(  e.messages.error, 'Error ' +  e.error, {type: 'warning'});
        },
        getParques(){
            this.fullscreenLoading = true;
            axios.post(`${process.env.API2}/v1/ab/listarrxparquexarbol`).then(response => {
                this.fullscreenLoading = false;
                this.listLugares=response.data;
            });
        },
        getEspecie(){
            this.fullscreenLoading = true;
            axios.post(`${process.env.API2}/v1/ab/listarrxtipoxparquexarbol`, {"text":this.ruleForm.lugar}).then(response => {
                this.fullscreenLoading = false;
                this.listEspecie=response.data;
            });
        },
        getPrecios(){
            this.fullscreenLoading = true;
            axios.post(`${process.env.API2}/v1/cc/result2`,
                {
                    "ue": "001066",
                    "sede" : this.ruleForm.lugar,
                    "areaId" : this.ruleForm.lugar,
                    "categoriaId" : "016",
                    "productoId" : ""
                }).then(response => {
                this.fullscreenLoading = false;
                this.listPrecios=response.data;
            });
        },
        changeTpodocument(){
            this.placeHolder.voucher = (this.ruleForm.voucher == 'B') ? 'DNI' : 'RUC';
            this.placeHolder.namebussines = (this.ruleForm.voucher == 'B') ? 'Nombres' : 'Razon social';
        },
        formDatas(obj) {
            let formData = new FormData();
            for (var key in obj) {
                formData.append(key, obj[key]);
            }
            return formData;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.step < this.totalSteps) this.step++;
                    if (this.step == this.totalSteps) {
                        this.step--;
                    }

                    this.detalleA = this.listLugares.filter(a => a.text.includes(this.ruleForm.lugar));
                    this.detalleB = this.listEspecie.filter(b => b.text.includes(this.ruleForm.especie));
                    this.detalleC = this.listPrecios.filter(c => c.productoId.includes(this.ruleForm.getSchedule));
                    this.ruleForm.nomproduct = this.detalleA[0].value + '<br> Especie: ' + this.detalleB[0].value + '<br>' + this.detalleC[0].productoDescripcion;
                    this.ruleForm.precio = this.detalleC[0].pUnitario;
                    //this.ruleForm.fcon = moment(this.ruleForm.fcon).format("YYYY-MM-DD");

                    if(this.ruleForm.metodo != 1){
                        if(this.ruleForm.idvoucher == null && this.step == 4)
                            return this.$alert( 'Falta subir su comprobante de pago', 'Error ', {type: 'warning'});
                    }

                    if (this.ruleForm.terms == true){
                        this.fullscreenLoading = true;
                        let formDatas = this.formDatas(this.ruleForm);
                        axios.post(`${process.env.API1}/raices/register`, formDatas).then(response => {
                            this.fullscreenLoading = false;
                            if (response.data.status == 'success') {
                                window.location.href = response.data.url
                            } else {
                                this.$alert(response.data.message, 'Lo sentimos!', {
                                    confirmButtonText: 'Entendido',
                                    type: 'error',
                                    center: true,
                                    callback: action => {}
                                });
                            }
                        });
                    }

                }
            });
        },
        getDedicatoria(){
            console.log('mes');
            this.ruleForm.mensaje = this.customs[this.ruleForm.motivo].name;
        }

    },
    created(){
        this.getParques();
    }
}
</script>

<style>
.input-with-select .el-select .el-input {width: 150px !important;}
.planes .el-radio__label{display: none !important;}
 /* Extra small devices (phones, 600px and down) */
@media screen and (max-width: 1920px) {

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media screen and (max-width: 1280px) {

}

/* Medium devices (landscape tablets, 768px and up) */
@media screen and (max-width: 768px) {
    .rv .el-step__title{
        line-height: 1.2;
        font-size: 15px;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media screen and (max-width: 480px) {
    .rv h3{
        font-size: 1.2rem;
    }
    .rv .el-step__title{
        line-height: 1.2;
        font-size: 15px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/raices/register.vue